<template>
  <div class="about bg-light">

  <top></top>

  <lead></lead>

  <applink></applink>

  <features></features>
  
  <applink></applink>
  
  <updates></updates>

  <bottom></bottom>




  </div>
</template>
<script>
import top from '../components/about/top.vue'
import lead from '../components/about/lead.vue'
import applink from '../components/about/applink.vue'
import features from '../components/about/features.vue'
import updates from '../components/about/updates.vue'
import bottom from '../components/about/bottom.vue'
export default {
  name: 'LandingPage',
  components: {
    top,
    lead,
    applink,
    features,
    updates,
    bottom
  },
  metaInfo: {
    title: 'Rhythm Reader（リズムリーダー）｜楽譜のリズムを音で聴ける無料Webリズムアプリ',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Rhythm Reader（リズムリーダー）は、音符を入力するだけでリズムを自動再生できる無料リズム練習Webアプリです。楽譜のリズムがわからない初心者も、スマホやPCで簡単にリズム確認・メトロノーム練習が可能。インストール不要で今すぐ使えます。'
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://rhythm-calculator.colour-field.jp/ja'
      },
      {
        rel: 'alternate',
        hreflang: 'ja',
        href: 'https://rhythm-calculator.colour-field.jp/ja'
      },
      {
        rel: 'alternate',
        hreflang: 'en',
        href: 'https://rhythm-calculator.colour-field.jp'
      },
      {
        rel: 'alternate',
        hreflang: 'x-default',
        href: 'https://rhythm-calculator.colour-field.jp'
      }
    ]
  },
}
</script>
<style scoped>
/*!
 * Start Bootstrap - Landing Page v5.0.7 (https://startbootstrap.com/template-overviews/landing-page)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-landing-page/blob/master/LICENSE)
 */

.about{
  font-family: 'Sawarabi Gothic', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 400;
}

</style>
